<template>
  <div class="header">
    <div class="menu" @click="menuHandler">
      <img src="./../../../assets/images/menu.png" />
    </div>
    <div class="title">{{ lotteryName }}</div>
    <img class="print" @click="printHandler" src="./../../../assets/images/print.png" />
  </div>
  <div class="lang-row"><LangSwitch /></div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import LangSwitch from '@/components/LangSwitch.vue';
defineProps({
  lotteryName: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['onPrintHandler', 'onMenuHandler']);
const printHandler = () => {
  emit('onPrintHandler');
};
const menuHandler = () => {
  emit('onMenuHandler');
};
</script>

<style lang="scss" scoped>
.lang-row {
  padding: 10px 20px;
}
.header {
  width: 100%;
  height: 100px;
  background: var(--brand-gradient);
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.18);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .menu,
  .print {
    width: 60px;
    height: 60px;
  }
  .menu {
    margin-left: 20px;
    img {
      width: inherit;
      height: inherit;
    }
  }
  .print {
    margin-right: 20px;
  }
  .title {
    color: #fff;
  }
}
</style>
